// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { promotionCodeFormStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPromotionCode";
import isMobile from "ismobilejs";
import { css } from "styled-components";

promotionCodeFormStyles.form = {
    css: css`
        position: relative;
    `,
};

promotionCodeFormStyles.applyButton = {
    sizeVariant: "small",
    css: css`
        position: absolute;
        right: 3px;
        top: ${isMobile().apple.device ? "30px" : "32px"};
    `,
};

promotionCodeFormStyles.applySuccessText = {
    color: "success",
    size: 14,
    css: css`
        margin-top: 10px;
    `,
};

promotionCodeFormStyles.applyPromotionGridItem = {
    width: [3, 3, 3, 3, 3],
    css: css`
        width: 100%;
        display: flex;
        align-items: flex-start;
        margin-top: 23px !important;
    `,
};

promotionCodeFormStyles.removeCodesLink = {
    color: "primary",
    css: css`
        margin-bottom: 8px;
    `,
};
